import { render } from "./designCodingPreview.vue?vue&type=template&id=bc39aee8"
import script from "./designCodingPreview.vue?vue&type=script&lang=js"
export * from "./designCodingPreview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__